import React from 'react'
import { createRoot } from 'react-dom/client'

import { App } from './App'
import './polyfills'
import { useAppStore } from './store/appStore/appStore'

window.global ||= window

// import reportWebVitals from './reportWebVitals'

const container = document.getElementById('root')!
const root = createRoot(container)

useAppStore.getState().initialize()

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
//

// reportWebVitals()
